import { useState } from 'preact/hooks';

const DEFAULT_SUGGESTIONS = ['CRS', 'QUA', 'XPS', 'ESXR', 'ITP'];

export const TagInput = ({ value = [], onChange, suggestions = DEFAULT_SUGGESTIONS }) => {
  const [draft, setDraft] = useState('');

  const add = (t) => {
    const tag = t.trim();
    if (!tag || value.includes(tag)) return;
    onChange([...value, tag]);
    setDraft('');
  };
  const remove = (t) => onChange(value.filter((x) => x !== t));

  const remainingSuggestions = suggestions.filter((s) => !value.includes(s));

  return (
    <div>
      <div class="flex flex-wrap items-center gap-1.5 rounded-md border border-border-strong bg-bg-card p-1.5">
        {value.map((t) => (
          <span key={t} class="inline-flex items-center gap-1 rounded-full border px-2 py-0.5 font-mono text-[11px]"
            style={{ background: 'rgba(245,238,220,0.10)', borderColor: 'rgba(212,201,176,0.4)', color: '#D4C9B0' }}>
            {t}
            <button type="button" onClick={() => remove(t)} class="text-text-muted hover:text-ink-magenta" aria-label={`Remove ${t}`}>×</button>
          </span>
        ))}
        <input
          class="min-w-24 flex-1 bg-transparent px-1 py-0.5 font-mono text-[11px] focus:outline-none"
          value={draft}
          onInput={(e) => setDraft(e.currentTarget.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ',') { e.preventDefault(); add(draft); }
            if (e.key === 'Backspace' && !draft && value.length) remove(value[value.length - 1]);
          }}
          onBlur={() => draft && add(draft)}
          placeholder="Add tag…"
        />
      </div>
      {remainingSuggestions.length > 0 && (
        <div class="mt-1.5 flex flex-wrap items-center gap-1">
          <span class="text-[10px] text-text-muted">Suggested:</span>
          {remainingSuggestions.map((s) => (
            <button
              key={s}
              type="button"
              onClick={() => add(s)}
              class="rounded-full border border-dashed border-border-tertiary px-2 py-0.5 font-mono text-[10px] text-text-tertiary hover:text-text-primary"
            >{s}</button>
          ))}
        </div>
      )}
    </div>
  );
};
